//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'VR',
  data() {
    return {
      active: 0,
      active1: 1,
      form: {
        co: '',
        map: '',
        cvp: '',
        bsa: '',
        mpap: '',
        pcwp: ''
      },
      hasScore: false,
      disabled: false,
      svr: '',
      svri: '',
      pvr: '',
      pvri: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    btnChange(v) {
      this.active = v
      this.hasScore = false
    },
    numChange(v) {
      this.active1 = v
      this.form.bsa = this.form.bsa
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      if (self.form.map == '') {
        self.form.map = '0'
      }
      if (self.form.cvp == '') {
        self.form.cvp = '0'
      }
      if (self.form.mpap == '') {
        self.form.mpap = '0'
      }
      if (self.form.pcwp == '') {
        self.form.pcwp = '0'
      }
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true
        if (self.active == 0) {
          if (self.active1 == 1) {
            self.svr = (((form.map - form.cvp) * 79.9 / form.co) / 79.9).toFixed(1)
            self.svri = (((form.map - form.cvp) * 79.9 / (form.co / form.bsa)) / 79.9).toFixed(1)
          } else {
            self.svr = ((form.map - form.cvp) * 79.9 / form.co).toFixed(1)
            self.svri = ((form.map - form.cvp) * 79.9 / (form.co / form.bsa)).toFixed(1)
          }
        } else {
          if (self.active1 == 1) {
            self.svr = (((form.mpap - form.pcwp) * 79.9 / form.co) / 79.9).toFixed(1)
            self.svri = (((form.mpap - form.pcwp) * 79.9 / (form.co / form.bsa)) / 79.9).toFixed(1)
          } else {
            self.svr = ((form.mpap - form.pcwp) * 79.9 / form.co).toFixed(1)
            self.svri = ((form.mpap - form.pcwp) * 79.9 / (form.co / form.bsa)).toFixed(1)
          }
        }
        // return String(self.svr.toFixed(1), self.svri.toFixed(0))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/VR.vue